var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#EDF0F4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.0784,
  cy: 25.0984,
  r: 1.56863,
  fill: "#2261F6"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.0784,
  cy: 6.90213,
  rx: 1.56863,
  ry: 1.56863,
  fill: "#2261F6"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.0781,
  cy: 11.5034,
  rx: 1.25491,
  ry: 1.25491,
  fill: "#2261F6"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.6865,
  cy: 9.20266,
  r: 1.25491,
  fill: "#2261F6"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.6865,
  cy: 22.9024,
  rx: 1.25491,
  ry: 1.25491,
  fill: "#2261F6"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 13.8565,
  r: 1.25491,
  fill: "#2261F6"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 18.1963,
  r: 1.25491,
  fill: "#2261F6"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.0781,
  cy: 20.4971,
  r: 1.25491,
  fill: "#2261F6"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.0784,
  cy: 16.0003,
  r: 0.993466,
  fill: "#2261F6"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.6868,
  cy: 18.2488,
  r: 0.993466,
  fill: "#2261F6"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.6868,
  cy: 13.8567,
  r: 0.993466,
  fill: "#2261F6"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.39902,
  cy: 11.5035,
  rx: 0.73203,
  ry: 0.73203,
  fill: "#2261F6"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.39902,
  cy: 16.0001,
  r: 0.73203,
  fill: "#2261F6"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.39902,
  cy: 20.4967,
  r: 0.73203,
  fill: "#2261F6"
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.0003,
  cy: 9.20291,
  rx: 1.56863,
  ry: 1.56863,
  fill: "#2261F6"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.0003,
  cy: 22.8499,
  r: 1.56863,
  fill: "#2261F6"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.9221,
  cy: 11.5037,
  r: 1.56863,
  fill: "#2261F6"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.9221,
  cy: 20.4969,
  rx: 1.56863,
  ry: 1.56863,
  fill: "#2261F6"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.9221,
  cy: 16.0003,
  r: 1.56863,
  fill: "#2261F6"
});

function SvgOxy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxy);
export default __webpack_public_path__ + "static/media/oxy.6b9880856daf4958498c8ec1208a1477.svg";
export { ForwardRef as ReactComponent };